module.exports = __webpack_public_path__ + "img/AL291-1.af1206c4.jpg";